import React from "react";

import PieChartComponent from "./components/PiChart";
import PageName from "../../shared/components/PageName";
import BarChartComponent from "./components/BarCharComponent";

import classes from "./StatisticsPage.module.css";

const StatisticsPage = () => {
  return (
    <div>
      <PageName pageName="Statistics" />
      <div className={classes["charts"]}>
        <PieChartComponent />
        <BarChartComponent />
      </div>
    </div>
  );
};

export default StatisticsPage;
